module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$hydrowareSecurityJS.canDisplay_A('compliancedoc') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Compliance Doc Management"
    }
  })], 1) : _c('div', {
    staticClass: "compliance_doc"
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [(this.$hydrowareCommonJS.showInnerPageHeading) ? _c('div', {
    staticClass: "div x_title"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "inner_title_buttons"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.isaddding) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddComplianceDocument('addCompliance')
      }
    }
  }, [_vm._v("\n                  Add Compliance Doc\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isediting && _vm.$hydrowareSecurityJS.canEdit_A('compliancedoc')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateComplianceDocument('addCompliance')
      }
    }
  }, [_vm._v("\n                    Update Compliance Doc\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.isediting || _vm.isaddding) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("List of Docs")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (!_vm.isediting && !_vm.isaddding) ? _c('div', [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "vue-tables-options"
    }
  }, [_c('v-client-table', {
    ref: "dragtable",
    staticClass: "hydroware-table",
    attrs: {
      "data": _vm.Documents,
      "columns": _vm.compliance_columns,
      "options": _vm.optionstable
    },
    scopedSlots: _vm._u([{
      key: "CreatedOn",
      fn: function(props) {
        return [_vm._v("\n                      " + _vm._s(_vm._f("fdate")(props.row.CreatedOn)) + "\n                  ")]
      }
    }, {
      key: "RevisedOn",
      fn: function(props) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("fdate")(props.row.CreatedOn)) + "\n                  ")]
      }
    }, {
      key: "ApprovedOn",
      fn: function(props) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("fdate")(props.row.CreatedOn)) + "\n                  ")]
      }
    }, {
      key: "AttachedFiles",
      fn: function(props) {
        return [(props.row.ComplianceDocumentFiles.length < 1) ? _c('span', [_vm._v("\n                      No attached files\n                    ")]) : _vm._e(), _vm._v(" "), _c('ul', {
          staticStyle: {
            "padding": "0px"
          }
        }, _vm._l((props.row.ComplianceDocumentFiles), function(certi, index) {
          return _c('li', {
            key: index,
            staticStyle: {
              "list-style": "none",
              "padding-top": "10px"
            }
          }, [_c('a', {
            attrs: {
              "href": _vm._f("dlinkc")(certi.DocumentPath),
              "download": ""
            }
          }, [_c('i', {
            staticClass: "fa fa-download",
            staticStyle: {
              "color": "#eb6145",
              "font-size": "1.4em",
              "padding-right": "8px"
            }
          }), _vm._v("\n                          " + _vm._s(certi.RealFileName) + "\n                        ")])])
        }), 0)]
      }
    }, {
      key: "Actions",
      fn: function(props) {
        return [_c('div', [_c('hydroware-viewOrEdit-button', {
          attrs: {
            "EV": _vm.$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('compliancedoc')
          },
          on: {
            "click": function($event) {
              return _vm.editcol(props)
            }
          }
        }), _vm._v(" "), (_vm.$hydrowareSecurityJS.canDelete_A('compliancedoc')) ? _c('hydroware-delete-button', {
          on: {
            "click": function($event) {
              return _vm.del(props)
            }
          }
        }) : _vm._e()], 1)]
      }
    }], null, false, 639150419)
  }, [(_vm.$hydrowareSecurityJS.canAdd_A('compliancedoc')) ? _c('hydroware-add-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isediting),
      expression: "!isediting"
    }],
    attrs: {
      "slot": "afterLimit"
    },
    on: {
      "click": function($event) {
        return _vm.addCompliancevit()
      }
    },
    slot: "afterLimit"
  }) : _vm._e()], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.isediting || _vm.isaddding) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('row', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('row', [_c('el-form', {
    ref: "addCompliance",
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "disabled": _vm.$hydrowareSecurityJS.disableDataEntry_A('compliancedoc', _vm.isAddingOrEditing),
      "model": _vm.addDocument,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "spellcheck": "false"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0px 20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('row', {
    staticClass: "col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addDocument.Title),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "Title", $$v)
      },
      expression: "addDocument.Title"
    }
  })], 1)], 1), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-form-item', {
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "label": "ID/Number:",
      "prop": "Number"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.addDocument.Number),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "Number", _vm._n($$v))
      },
      expression: "addDocument.Number"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Revision:",
      "prop": "Revision"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.addDocument.Revision),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "Revision", _vm._n($$v))
      },
      expression: "addDocument.Revision"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Created By:",
      "prop": "CreatedBy"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.addDocument.CreatedBy),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "CreatedBy", $$v)
      },
      expression: "addDocument.CreatedBy"
    }
  }, _vm._l((_vm.Users), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Created Date::",
      "prop": "CreatedOn"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "MM-dd-yyyy",
      "placeholder": "Pick a date"
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.addDocument.CreatedOn),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "CreatedOn", $$v)
      },
      expression: "addDocument.CreatedOn"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Revised By:",
      "prop": "RevisedBy"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.addDocument.RevisedBy),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "RevisedBy", $$v)
      },
      expression: "addDocument.RevisedBy"
    }
  }, _vm._l((_vm.Users), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Revision Date:",
      "prop": "RevisedOn"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "MM-dd-yyyy",
      "placeholder": "Pick a date"
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.addDocument.RevisedOn),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "RevisedOn", $$v)
      },
      expression: "addDocument.RevisedOn"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Approved By:",
      "prop": "ApprovedBy"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.addDocument.ApprovedBy),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "ApprovedBy", $$v)
      },
      expression: "addDocument.ApprovedBy"
    }
  }, _vm._l((_vm.Users), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Approved On:",
      "prop": "ApprovedOn"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "MM-dd-yyyy",
      "placeholder": "Pick a date"
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.addDocument.ApprovedOn),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "ApprovedOn", $$v)
      },
      expression: "addDocument.ApprovedOn"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Document Control Notes:",
      "prop": "Notes"
    }
  }, [_c('el-input', {
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "type": "textarea",
      "rows": 20,
      "maxlength": 400
    },
    model: {
      value: (_vm.addDocument.Notes),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "Notes", $$v)
      },
      expression: "addDocument.Notes"
    }
  })], 1)], 1)])])])])])], 1), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "form-group col-lg-6 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-6",
    class: [{
      hydroware_hidden: _vm.$hydrowareSecurityJS.disableDataEntry_A('compliancedoc', _vm.isAddingOrEditing)
    }]
  }, [_c('label', {
    staticClass: "control-label col-lg-6"
  }, [_vm._v("File Upload: ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "btn-wrap",
    staticStyle: {
      "padding": "0px 32px",
      "font-size": "20px"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" \n                            Upload\n                          ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "Attachments",
      "multiple": "",
      "id": "files"
    },
    on: {
      "change": _vm.setAttachment
    }
  })])]), _vm._v(" "), (_vm.addDocument.ComplianceDocumentFiles) ? _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('el-dropdown', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n                          Files"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.addDocument.ComplianceDocumentFiles), function(files, index) {
    return _c('el-dropdown-item', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": _vm._f("dlinkc")(files.DocumentPath),
        "download": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "color": "#eb6145",
        "font-size": "1.4em",
        "padding-right": "8px"
      }
    }), _vm._v("\n                              " + _vm._s(files.RealFileName) + "\n                            ")])])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-danger col-lg-3",
    class: [{
      hydroware_hidden: _vm.$hydrowareSecurityJS.disableDataEntry_A('compliancedoc', _vm.isAddingOrEditing)
    }]
  }, [_c('el-checkbox', {
    staticClass: "hydroware-editNoEdit",
    staticStyle: {
      "padding-left": "0px",
      "text-overflow": "inherit",
      "overflow": "inherit"
    },
    attrs: {
      "disabled": _vm.$hydrowareSecurityJS.disableDataEntry_A('compliancedoc', _vm.isAddingOrEditing)
    },
    model: {
      value: (_vm.addDocument.ForAllLocations),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "ForAllLocations", $$v)
      },
      expression: "addDocument.ForAllLocations"
    }
  }, [_vm._v("\n                        Update To All Locations\n                      ")])], 1)])]), _vm._v(" "), _c('row', [(_vm.isAddingOrEditing != 'V' &&
    (_vm.$hydrowareSecurityJS.canEdit_A('compliancedoc') || _vm.$hydrowareSecurityJS.canAdd_A('compliancedoc'))) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "-15px",
      "margin-bottom": "10px"
    }
  }, _vm._l((_vm.uploadFileHelperArray), function(tag) {
    return (tag.action == 0 || tag.action == 2) ? _c('el-tag', {
      key: tag,
      attrs: {
        "closable": true,
        "type": _vm.attachmentcolor
      },
      on: {
        "close": function($event) {
          return _vm.removeAttachedFile(tag)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tag.ComplianceDocumentRealFileName) + "\n                    ")]) : _vm._e()
  }), 1) : _vm._e()]), _vm._v(" "), _c('row', {
    staticClass: "col-lg-12"
  }, [_c('div', [_c('h4', {
    staticStyle: {
      "float": "left",
      "padding-left": "10px",
      "font-weight": "700"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("\n                        NOTE: You can use the area below to create a document if you don't have one to upload\n                      ")])]), _vm._v(" "), _c('BR')], 1), _vm._v(" "), _c('span', {
    staticClass: "hydroware-editNoEdit"
  }, [_c('wisi', {
    attrs: {
      "disabled": _vm.$hydrowareSecurityJS.disableDataEntry_A('compliancedoc', _vm.isAddingOrEditing)
    },
    model: {
      value: (_vm.addDocument.Instructions),
      callback: function($$v) {
        _vm.$set(_vm.addDocument, "Instructions", $$v)
      },
      expression: "addDocument.Instructions"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 inner_title_buttons"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.isediting || _vm.isaddding) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("List of Docs")])]) : _vm._e(), _vm._v(" "), (!_vm.isediting) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddComplianceDocument('addCompliance')
      }
    }
  }, [_vm._v("\n                    Add Compliance Doc\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.isediting && _vm.$hydrowareSecurityJS.canEdit_A('compliancedoc')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateComplianceDocument('addCompliance')
      }
    }
  }, [_vm._v("\n                    Update Compliance Doc\n                  ")]) : _vm._e()], 1)])], 1)]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('b', [_c('i', {
    staticClass: "fa fa-book fa-1x",
    staticStyle: {
      "color": "white !important"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _vm._v("\n              Compliance Doc Management\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticStyle: {
      "float": "left",
      "padding-left": "10px",
      "font-weight": "700"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("\n                    Document Control Detail\n                  ")])]), _vm._v(" "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27fe017c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Compliance/compliance_doc.vue
// module id = 789
// module chunks = 1